import React from "react";
import { Container, Row, Button } from "react-bootstrap";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';


function Resume() {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <Container fluid className="resume-section">
            <Particle />
            <Container>
                <Row style={{ justifyContent: "center", position: "relative" }}>
                    <Button variant="primary" href="/assets/Khan_Mohammed_Resume.pdf" download>
                        <i className="fas fa-download">&nbsp;</i>Download Resume
                    </Button>
                </Row>
                <Row style={{ justifyItems: "center", marginTop: "20px" }}>
                    <div style={{ height: '800px', width: '100%' }}>
                        {/* PDF.js Worker for better performance */}
                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                            <Viewer fileUrl="/assets/Khan_Mohammed_Resume.pdf" plugins={[defaultLayoutPluginInstance]} />
                        </Worker>
                    </div>
                </Row>
            </Container>
        </Container>
    );
}

export default Resume;
